
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeavyRainShowersNightColour as ObiHeavyRainShowersNightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heavy-rain-showers-night-colour.js';
 
 
 

 
 export const ObiHeavyRainShowersNightColour = createComponent({
   react: React,
   tagName: 'obi-heavy-rain-showers-night-colour',
   elementClass: ObiHeavyRainShowersNightColourElement,
   events: {
     
   }
  });
 
 